import { DISCUSSION_LIMITS, textRows } from 'lib/community/discussions-writer'
import styles from './Writer.module.css'

interface TextBlockProps {
  body: string
  onChange: (value: string) => void
}

/** A paragraph run: blank lines split paragraphs when DealHunt renders it (contract §2). */
const TextBlock: React.VFC<TextBlockProps> = ({ body, onChange }) => (
  <textarea
    className={styles.text}
    value={body}
    rows={textRows(body)}
    maxLength={DISCUSSION_LIMITS.textChars}
    placeholder="Write here. Say what you've tried, what you use it for, what matters to you."
    aria-label="Text"
    onChange={e => onChange(e.target.value)}
  />
)

export default TextBlock
